import React from 'react'

type Style = React.CSSProperties

export const documentationCardStyles: Record<string, Style> = {
  boxContainer: {
    display: 'flex',
    position: 'relative',
    flexDirection: 'column',
    justifyContent: 'space-evenly',
    alignItems: 'center',
    backgroundColor: 'white',
    width: '45%',
    height: '100%',
    borderRadius: 6,
    marginRight: '2%',
    boxShadow: '0px 4px 74px rgba(0, 0, 0, 0.13)',
    maxWidth: 500,
    padding: 16
  },
  tooltipContainer: {
    position: 'absolute',
    top: 8,
    right: 8,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }
}
